import {PhoneView, SimpleText} from '../../styles/CommonComponents.jsx';
import {styles} from '../../styles/common/styles.js';
function Circle(props) {
  return (
    <PhoneView
      style={{
        ...props.style,
        ...styles.justifyContentCenter,
        ...styles.alignItemsCenter,
        overflow: 'hidden',
        width: props.width || 60,
        height: props.height || 20,
        backgroundColor: props.backgroundColor,
        ...{
          borderRadius: props.borderRadius || 7,
        },
      }}>
      {props.child}
      <SimpleText
        text={props.text}
        style={{
          color: props.color,
        }}
      />
    </PhoneView>
  );
}
export default Circle;
